<template>
    <div class="boxShow">
        <div :class="isMobile?'mainBoxs':'mainBox'">
            <span class="bTitle">业务办理</span>
            <div class="businessBox">
                <div :class="isMobile?'businessItems':'businessItem'" v-for="(item,index) in serverList" :key="index" @click="jigouGoin(item.href)">
                    <img class="serverImg" :src="item.imgUrl" alt="">
                    <p class="serverName">{{ item.name }}</p>
                </div>
            </div>
        </div>
        <el-carousel
            v-if="bannerImageList.length > 0"
            :class="isMobile?'jingsImgs':'jingsImg'"
            :indicator-position="bannerImageList.length == 1 ? 'none' : ''"
            height="140px"
            arrow="never"
        >
            <el-carousel-item
                v-for="item of bannerImageList"
                :key="item.RowGuid"
            >
                <img
                    :src="item.Picture"
                    style="width: 100%;"
                />
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                serverList:[
                    {
                        imgUrl:require('@/assets/home/ser1.png'),
                        name:'入会申请',
                        href:'http://member.hbaec.com/Jzxh/Web/Dw/DwRegister.aspx'
                    },
                    {
                        imgUrl:require('@/assets/home/ser2.png'),
                        name:'工程咨询单位备案',
                        href:'https://new.tzxm.gov.cn/'
                    },
                    {
                        imgUrl:require('@/assets/home/ser3.png'),
                        name:'资信评价系统',
                        href:'https://zhywglxt.cnaec.com.cn/#/consultant_login?redirect=%2F'
                    },
                    {
                        imgUrl:require('@/assets/home/ser4.png'),
                        name:'信用评价系统',
                        href:'2'
                    },
                    {
                        imgUrl:require('@/assets/home/ser5.png'),
                        name:'执业检查',
                        href:'2'
                        //href:'http://zyjc.hbaec.com/zyjc/classfiy' //线上
                        // href:'http://192.168.1.56:3000/zyjc/classfiy' //本地
                    },
                    {
                        imgUrl:require('@/assets/home/ser6.png'),
                        name:'优秀成果申报',
                        href:'2'
                        //href:'http://yxcg.hbaec.com/user/login' //线上
                        // href:'http://192.168.1.56:4000/user/login' //本地
                    },
                    {
                        imgUrl:require('@/assets/home/ser7.png'),
                        name:'咨询师考试',
                        href:'http://www.cpta.com.cn/test/1065.html'
                    },
                    {
                        imgUrl:require('@/assets/home/ser8.png'),
                        name:'咨询师登记',
                        href:'https://www.cnaec.com.cn/zxsd.html'
                        // href:'https://www.cnaec.com.cn/'
                    },
                    {
                        imgUrl:require('@/assets/home/ser9.png'),
                        name:'咨询师继续教育',
                        href:'3'
                        // href:'https://zxgcsjxjy.lanmaiedu.com/index.html'
                    },
                    {
                        imgUrl:require('@/assets/home/ser10.png'),
                        name:'专业培训',
                        href: '2',
                        // href:'http://ksls.ruihepm.com/Jzxh/Login.aspx'
                    },
                    {
                        imgUrl:require('@/assets/home/ser11.png'),
                        name:'咨询专家库',
                        // href:'2'
                        href:'http://zjk.hbaec.com/'
                    },
                    {
                        imgUrl:require('@/assets/home/ser12.png'),
                        name:'会员登录',
                        href:'http://member.hbaec.com/Jzxh/Login.aspx'
                    }
                ],
                bannerImageList: [],
            }
        },
        methods:{
            //  服务平台/ 咨询机构业务办理 /咨询工程师业务办理
            jigouGoin(href){
                if(href==1){ //入会申请 表单填写(现在没有这个了)
                    return
                }else if(href==2){ //功能还在研发中 
                    this.$message.info('正在研发，敬请期待')
                    return
                }else if(href==3){
                    this.$router.push({
                        path:'/turnCenter'
                    })
                }else{
                    window.open(href,'_blank')
                }
            },
            getBannerImageList() {
                this.Request({
                    url: "/api/NewsData/GetHimg",
                    method: "get",
                }).then((data) => {
                    this.bannerImageList = data.Data;
                });
            },
        },
        created() {
            this.getBannerImageList();
        },
    }
</script>

<style scoped>
    .boxShow{
        width: 100%;
    }
    .mainBox{
        width: 1400px;
        margin: 0 auto;
        padding: 20px;
        background-color: #fff;
    }
    .mainBoxs{
        width: 100%;
        padding: 20px;
        background-color: #fff;
    }
    .bTitle{
        font-size: 20px;
        font-weight: bold;
        padding-bottom: 10px;
        color: #0d69f0;
        border-bottom: 2px solid #0d69f0;
    }
    .businessBox{
        margin-top: 40px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .businessItem{
        width: calc((100% - 100px)/6);
        margin-bottom: 15px;
        margin-right: 20px;
        padding: 25px;
        background-color: #EDEEF2;
        border-radius: 10px;
        cursor: pointer;
        text-align: center;
    }
    .businessItem:nth-child(6n){
        margin-right: 0;
    }
    .businessItems{
        width: calc((100% - 20px) /3);
        margin-bottom: 15px;
        margin-right: 10px;
        padding: 10px;
        background-color: #EDEEF2;
        border-radius: 10px;
        cursor: pointer;
        text-align: center;
    }
    .businessItems:nth-child(3n){
        margin-right: 0;
    }
    .serverImg{
        display: block;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin: 0 auto;
        margin-bottom: 20px;
    }
    .businessItem:hover{
        box-shadow: 5px 5px 10px rgba(0,0,0,0.2);
    }
    .jingsImg{
        display: block;
        width: 1400px;
        margin: 0 auto;
        margin-top: 20px;
    }
    .jingsImgs{
        display: block;
        width: calc(100% - 20px);
        margin: 0 auto;
        margin-top: 20px;
    }

    .jingsImgs >>> .el-carousel__container {
        height: auto !important;
        aspect-ratio: 9022 / 906;
    }
</style>